import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { memo, useCallback } from 'react';

import { FormattedCurrency } from '@/components/Formatted/FormattedCurrency';
import { useAppSelector } from '@/redux/hooks';
import { getBidIncrementsByCatalogId } from '@/redux/modules/bidIncrements/bidIncrements.selectors';
import { getCatalogCurrency } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { BidIncrement } from '@/types/BidIncrement';

import { DescriptionSection } from '../ItemDescription/DescriptionSection';

type Props = {
    catalogId: number;
};

const BidIncrementsComponent = ({ catalogId }: Props) => {
    const bidIncrements = useAppSelector((state) => getBidIncrementsByCatalogId(state, catalogId));
    const currency = useAppSelector((state) => getCatalogCurrency(state, catalogId));

    const mapBidIncrements = useCallback(
        (item: BidIncrement, index: number) => {
            return (
                <div
                    className="border-b border-border-secondary py-xs"
                    key={index}
                >
                    <span className="inline-block w-1/2 max-w-[200px]">
                        <FormattedCurrency
                            convert
                            key={`bid-increment-from-amount-${index}`}
                            noFraction
                            sourceCurrency={currency}
                            value={item.fromAmount}
                        />
                    </span>
                    <span className="inline-block w-1/2 max-w-[200px]">
                        <FormattedCurrency
                            convert
                            key={`bid-increment-increment-amount-${index}`}
                            noFraction
                            sourceCurrency={currency}
                            value={item.incAmount}
                        />
                    </span>
                </div>
            );
        },
        [currency]
    );

    return (
        <DescriptionSection
            body={
                <div className="block !max-w-[380px]">
                    <div className="border-b border-border-secondary py-xs">
                        <span className="inline-block w-1/2 max-w-[200px]">
                            <span className="font-[Inter]">
                                <FormattedMessage id="price" />
                            </span>
                        </span>
                        <span className="inline-block w-1/2 max-w-[200px]">
                            <span className="font-[Inter]">
                                <FormattedMessage id="bid_increment" />
                            </span>
                        </span>
                    </div>
                    {bidIncrements.map(mapBidIncrements)}
                </div>
            }
            header="bid_increments"
        />
    );
};

export const BidIncrements = memo<Props>(BidIncrementsComponent);
